import FusionCharts from './../vendors/fc-core/src/constructor';
import defaultFeatures from '../features';
FusionCharts.addDep(defaultFeatures);
export default FusionCharts;